import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    padding: '0px !important',
    maxWidth: '1440px !important',
  },
}));
